
import { MapTo } from '@adobe/aem-react-editable-components';
import InterestEarningCalculator, { InterestEarningCalculatorEditConfig } from './InterestEarningCalculator';

export default MapTo('cob-corp-acquisition/components/creditonebank/interest-earning-calculator')(InterestEarningCalculator, InterestEarningCalculatorEditConfig);
        